<template>
  <article class="ai-summary-card">
    <div class="ai-summary-icon"><b-icon :icon="icon" /></div>
    <div><span>{{ label }}</span><strong>{{ value }}</strong><small v-if="hint">{{ hint }}</small></div>
  </article>
</template>
<script>
export default { props: { label: String, value: [String, Number], hint: String, icon: { type: String, default: 'stars' } } }
</script>

